
/**
 * All the navbar related methods.
 */

+function($){

  page.initNavbar = function() {

    /**
     * Toggle navbar
     */
    $(document).on('click', '.navbar-toggler', function() {
      page.navbarToggle();
    });


    /**
     * Tapping on the backdrop will close the navbar
     */
    $(document).on('click', '.backdrop-navbar', function() {
      page.navbarClose();
    });

  }


  page.navbarToggle = function() {
    var body   = page.body,
        navbar = page.navbar;

    body.toggleClass('navbar-open');
    if (body.hasClass('navbar-open')) {
      navbar.prepend('<div class="backdrop backdrop-navbar"></div>');
    }
  }

  page.navbarClose = function() {
    page.body.removeClass('navbar-open');
    $('.backdrop-navbar').remove();
  }

}(jQuery);



//////////////////
// WEBPACK FOOTER
// ./src/assets/plugin/thesaas/js/partials/navbar.js
// module id = 72
// module chunks = 0